export default __webpack_public_path__ + "static/media/social_media.d23e34c9.svg";